import { useEffect, useState } from "react";
import { CloudOff, RefreshCw, WifiOff } from "lucide-react";
import { useChat } from "@/lib/chat";

// Slim bar under the top bar: "offline" (browser has no network) or "reconnecting" (network OK but realtime link down).
export const ConnectionBanner = () => {
  const { connected, outboxCount, retryNow } = useChat();
  const [online, setOnline] = useState(typeof navigator === "undefined" ? true : navigator.onLine);
  const [showDisc, setShowDisc] = useState(false);
  useEffect(() => {
    const up = () => setOnline(true);
    const down = () => setOnline(false);
    window.addEventListener("online", up);
    window.addEventListener("offline", down);
    return () => { window.removeEventListener("online", up); window.removeEventListener("offline", down); };
  }, []);
  useEffect(() => {
    if (connected) { setShowDisc(false); return undefined; }
    const t = setTimeout(() => setShowDisc(true), 2500); // ignore sub-second blips
    return () => clearTimeout(t);
  }, [connected]);
  if (online && (connected || !showDisc)) return null;
  const queued = outboxCount ? ` · ${outboxCount} message${outboxCount === 1 ? "" : "s"} will send automatically` : "";
  return (
    <div className={`tc-connbar is-${online ? "reconnecting" : "offline"}`} role="status" data-testid="connection-banner" data-state={online ? "reconnecting" : "offline"}>
      {online ? <RefreshCw size={14} className="spin" /> : <WifiOff size={14} />}
      <span>{online ? "Reconnecting to Total Chat…" : "You're offline — you can keep reading and typing"}{queued}</span>
      <span className="grow" />
      {online && <button className="tc-connbar__btn" onClick={retryNow} data-testid="connection-retry">Try now</button>}
      {!online && <CloudOff size={14} className="muted" />}
    </div>
  );
};
